import { use, useCallback, useContext, useEffect, useState } from "react"
import { GridLayout, HorizontalLayout, VerticalLayout } from "./layout"
import { NavItem } from "../atoms/navItem"
import { SocialPreview } from "./socialPreview"
import { ButtonGroup, IconButton, ModalButton, StandardButton } from "../atoms/buttons"
import { TextAtom } from "../atoms/TextAtom"
import { PageContext, ToastContext, UserContext } from "../App"
import { TitleAtom } from "../atoms/titleAtom"
import { icon } from "../functions/icons"
import { TitleDescription } from "./titleDescription"
import { EditCourseModal } from "./customModals"
import { Alert } from "./alert"
import CourseInfo from "../molecule/CourseInfo"
import { UserContact } from "../molecule/userContact"
import { User } from "../atoms/user"
import { InputForm, TextAreaForm } from "../atoms/input"
import Checkbox from "../atoms/checkboxnew"
import { getAPI, postAPI, updateAPI } from "../api/api"
import DepartmentSelectors from "../molecule/departmentSelector"
import { ip } from '../api/api'
import { margin, padding } from "polished"
import { Spinner } from "../atoms/spinner"
import { Search } from "../atoms/search"
import { IconText } from "./courseComp"
import { IconAtom2 } from "../atoms/iconAtom"
import { StandardComp } from "../atoms/standardComp"
import { TitleDescriptionText } from "../atoms/titleDescription"
import { min, set } from "date-fns"
import { ToggleSwitch } from "../molecule/ToggleSwitch"


export const PublishActionComp = ({ data, loadCourse, quizStructure, setScoreModalVisible }) => {


    const [activeScreen, setActiveScreen] = useState(1)
    return (
        <HorizontalLayout className="publish-navigation-comp">
            <PublishNavigation activeScreen={activeScreen} onClick={setActiveScreen} />
            <NavigationActions setScoreModalVisible={setScoreModalVisible} quizStructure={quizStructure} loadCourse={loadCourse} data={data} actions={activeScreen} />
        </HorizontalLayout>
    )
}

const PublishNavigation = ({ activeScreen, onClick }) => {
    const navigation = [
        {
            "id": 1,
            "icon": "book"
        },
        {
            "id": 2,
            "icon": "share"
        },
        {
            "id": 3,
            "icon": "mail"
        },
        {
            "id": 4,
            "icon": "department"
        },
        {
            "id": 5,
            "icon": "card"
        },
        {
            "id": 6,
            "icon": "setting"
        }
    ]
    const isPublic = useContext(UserContext).account_type === 1
    return (
        <VerticalLayout className="publish-nav" style={{ backgroundColor: !isPublic && "var(--primary-50)" }}>
            {navigation.map((nav) => {
                return (
                    <NavItem
                        style={{ width: "unset", padding: "0.5rem", justifyContent: "center", alignItems: "center" }}
                        onClick={() => onClick(nav.id)}
                        icon2={nav.icon}
                        active={nav.id === activeScreen}
                    />
                )
            }
            )
            }
        </VerticalLayout>

    )
}


const NavigationActions = ({ actions, data, loadCourse,quizStructure, setScoreModalVisible }) => {
    switch (actions) {
        case 1: return (<CourseInfo quizStructure={quizStructure} courseData={data} loadCourse={loadCourse} setScoreModalVisible={setScoreModalVisible}/> )
        case 2: return <Social data={data} />
        case 3: return <EmailLeads />
        case 4: return (<DepartmentSelectors />)
        case 5: return <TapToLearnShare />
        case 6: return <SettingsPage courseId={data?.id_course} />
        default: return
        
    }
}

const TapToLearnShare = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [leads, setLeads] = useState([]);
    const [selectedLeads, setSelectedLeads] = useState([]);
    const [selectLoader, setSelectLoading] = useState(false);
    const [sortType, setSortType] = useState("status");
    const [loading, setLoading] = useState(false);
    const navigationContext = useContext(PageContext);
    const sortOptions = {
        newest: { title: "Nieuwste", icon: "arrow-down" },
        oldest: { title: "Oudste", icon: "arrow-up" },
        name: { title: "Naam A–Z", icon: "alphabet" },
        status: { title: "Actieve", icon: "status" },
        unselected: { title: "Niet gekoppeld", icon: "not-connected" },
    };
    const getLeads = async () => {
        setLoading(true);
        const order = sortType === "oldest" ? "ASC" : "DESC";
        const query = `api/cards/leads?search=${searchTerm}&sort=${sortType}&order=${order}&id_course=${navigationContext.sidebar.courseID}`;
        const res = await getAPI(query);
        console.log("leads",res);
        if (res.status === "ok") {
        let list = res.data;
        const selected = list.filter(l => l.active).map(l => l.id_card);
        if (sortType === "unselected") {
            list = [
                ...list.filter(l => !l.active), 
                ...list.filter(l => l.active) 
            ];
        }

        setLeads(list);
        setSelectedLeads(selected);
    }
        setLoading(false);
    };  
    useEffect(() => {
        getLeads();
    }, [searchTerm, sortType]);

    const handleSortChange = () => {
        const keys = Object.keys(sortOptions);
        const currentIndex = keys.indexOf(sortType);
        const nextIndex = (currentIndex + 1) % keys.length;
        setSortType(keys[nextIndex]);
    };
    const handleSelectLead = (id_card) => {
        setSelectedLeads(prev => {
            const updated = prev.includes(id_card) ? prev.filter(id => id !== id_card) : [...prev, id_card]
            setLeads(l => l.map(lead => ({ ...lead, active: updated.includes(lead.id_card) })) );
            const body = { id_course: navigationContext.sidebar.courseID, id_cards: updated };
            console.log("body for select lead:", body);
            postAPI("api/cards/add-course", body);
            return updated;
        });
    };
    const toggleAll = async () => {
        setSelectLoading(true);
        const allSelected = selectedLeads.length === leads.length;
        const updated = allSelected ? [] : leads.map(l => l.id_card);

        setSelectedLeads(updated);
        setLeads(l => l.map(lead => ({ ...lead, active: updated.includes(lead.id_card) })));
        await postAPI("api/cards/add-course", {
            id_course: navigationContext.sidebar.courseID,
            id_cards: updated
        });
        setSelectLoading(false);
    };

    const selectedCount = selectedLeads.length;
    const allSelected = leads.length > 0 && selectedCount === leads.length;
    return (
        <VerticalLayout>
            <TitleAtom className={"standard-margin"} title={"Tap to Learn"} />
            <SearchAndFilter searchTerm={searchTerm}  setSearchTerm={setSearchTerm} sortType={sortType} sortOptions={sortOptions} onSortChange={handleSortChange} onChange={toggleAll} checked={allSelected}/>
            {loading ? <VerticalLayout className="center"><Spinner /></VerticalLayout> : <LeadCardList selectedLeads={selectedLeads} onSelectLead={handleSelectLead} leads={leads} />}
        </VerticalLayout>   
    )
}

const LeadCardList = ({ leads, selectedLeads, onSelectLead  }) => {

    return (
        <VerticalLayout style={{ width: "auto", gap: "1rem", maxHeight: "400px", overflowY: "auto" }} className="standard-margin">
            {leads.map(lead => (
                <LeadCard isSelected={selectedLeads.includes(lead.id_card)} key={lead.id_card} lead={lead} onSelectLead={onSelectLead} />
            ))}
        </VerticalLayout>
    )
}

const LeadCard = ({ lead, isSelected, onSelectLead  }) => {
    const getStatusColor = (status) => {
        switch (status) {
            case 0:
                return "var(--grey-400)"; 
            case 1:
                return "var(--success-600)"; 
            default:
                return "var(--grey-400)";
        }
    };

    return (
        <StandardComp
            onClick={() => onSelectLead(lead.id_card)}
            style={{ padding:"1rem", width: "auto"}}
            editClass={`no-margin lead-cards ${isSelected ? "selected" : ""}`}
            content={
                <>
                <HorizontalLayout className="space-between lead-name-container" style={{ width: "unset", alignItems: "center" }}>
                    {icon("status", 15,getStatusColor(lead.status))}
                    {isSelected && icon("check", 15, "var(--primary-600)")}
                </HorizontalLayout>
                <TextAtom className="lead-name" title={lead.first_name || lead.last_name ? `${lead.first_name || ""} ${lead.last_name || ""}`.trim() : !lead.email && "Kaart niet gekoppelt" } />
                <TextAtom className={"lead-email"} title={lead.email} />
                {lead.company_name && <TextAtom className={"lead-company"} title={lead.company_name} />}
                </>
        } />
    )
}
const SearchAndFilter = ({ searchTerm, setSearchTerm, sortType, sortOptions, onSortChange, onChange, checked }) => {
    const currentSort = sortOptions[sortType];
    return (
        <HorizontalLayout style={{ margin: "1rem 1rem 1rem .25rem", width: "auto" }}>
            <Search
                className="tap-to-learn-search"
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Zoek lead"
            />
            <StandardButton
                onClick={onSortChange}
                backgroundColor="transparent"
                textColor="primary-600"
                className="sort-icon"
                style={{
                    minWidth: "10rem",
                    border: "1px solid var(--grey-400)",
                    marginRight: ".5rem",
                    padding: ".75rem 1.5rem",
                    display: "flex",
                    alignItems: "center",
                    gap: ".5rem",
                }}
                title={currentSort.title}
            >
                {icon(currentSort.icon, 17, currentSort.icon === "status" ? "var(--success-600)" : "var(--primary-600)")}
            </StandardButton>
               <ToggleSwitch
                    // leftTitle={checked ? "Deselecteer alles" : "Selecteer alles"}
                    className={`department-switch ${checked ? "active" : ""}`}
                    checked={checked}
                    onChange={onChange}
                />
        </HorizontalLayout>
    );
};

export const Social = ({ data }) => {
    const [view, setView] = useState(false)
    const [aiLoading, setAiLoading] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [postInfo, setPostInfo] = useState({})
     const [linkedinMessage, setLinkedinMessage] = useState("")
    const [aiReload, setAiReload] = useState(false)
    const [collapse, setCollapse] = useState(false)
    const [open, setOpen] = useState(false)
    const toastContext = useContext(ToastContext);
    const handleView = () => {setView(!view)}
    const handleInput = (text) => {
        setLinkedinMessage(text)
        updateLinkedinPost(text) 
    }   
    const updateLinkedinPost = async (message) => {
        const query = `api/marketing/${data.id_course}/linkedin-post/update`
        const body = { post_text: message, id_post: postInfo.id_post, status: postInfo.status }
        await updateAPI(query, body);
    }
    const LoadLinkedinPost = async () => {
        setIsLoading(true)
        const query = `api/marketing/${data.id_course}/linkedin-post`
        const res = await getAPI(query);
        console.log("res", res)
        if (res.status === "ok") {
            setPostInfo(res.data || {})
        }
        setIsLoading(false)
    }
    const handleAiLinkedin = async () => {
        setAiLoading(true);
        const query = "api/marketing/generate/linkedin-post"
        console.log("data", data)
        const res = await postAPI(query, data);
        console.log("res", res)
        if (res.status === "ok"){
            setAiReload(true)
            toastContext.showToast(<>AI-beschrijving succesvol gegenereerd!</>, "success", 1500);
            handleInput(res.data.post_text)
        }
        setAiLoading(false);    
    }
    useEffect(() => {
    if (postInfo?.post_text) {
        setLinkedinMessage(postInfo.post_text)
    }
    }, [postInfo])
    useEffect(() => {
        LoadLinkedinPost()
    }, [])
    return (
        <VerticalLayout >
            <TitleAtom className={"standard-margin"} title={"Deel op je sociale kanalen"} />
            {!isLoading ? (<>  
            <TextAreaForm placeholder={"Deel een update op LinkedIn over je nieuwe e-learning! ✨"} size={open ? "large" : ""} open={open} collapse={() => {setCollapse(!collapse); setOpen(!open)}} aiLoading={aiLoading} aiReload={aiReload} handleAiGenerate={handleAiLinkedin} AI={true} title={"Linkedin bericht"} typeInput={handleInput} value={linkedinMessage} style={{ margin: "1rem", width: "unset", minHeight: collapse ? "16rem": "3rem", marginTop:"0rem", backgroundColor:"#F7F7F7", padding:"0.5rem" , borderRadius:"0.3rem"}} textAreaStyle={{minHeight:"max-content"}} />
            <SocialPreview open={open} message={linkedinMessage} data={data} /> 
            <ActionHandler  active={true} onClick={handleView} />
            </>) : (<VerticalLayout className="center"><Spinner /></VerticalLayout>) }
          
        </VerticalLayout>)
}

const ActionHandler = ({ onClick, active }) => {
    const alerts = useContext(ToastContext)
    const navigation = useContext(PageContext)
    const copyUrl = () => {
        navigator.clipboard.writeText(`${ip}/embed/${navigation.sidebar.courseID}`)
        alerts.showToast(<>URL gekopieerd</>, "success")
    }
    return (
        <HorizontalLayout style={{ width: "unset", margin: "1rem", marginTop: "auto", gap: "1rem" }}>


            {active === true &&
                <>
                    <IconButton
                        onClick={copyUrl}
                        style={{ height: "100%", width: "2.5rem", borderRadius: "0.2rem", backgroundColor: "var(--primary-50)" }}
                        color={"black"}
                        icon2={"url"}
                    />
                    <ModalButton
                        onClick={onClick}
                        title={"Post op linkedin"}
                        style={{ marginTop: "auto", height: "100%", width: "100%" }}
                    />
                </>}


        </HorizontalLayout>
    )
}


export const EmailLeads = ({ }) => {
    const [extraUser, setExtraUser] = useState(false)
    const [leadData, setLeadData] = useState({ name: "", email: "", })
    const [leads, setLeads] = useState([])
    const [isActive, setIsActive] = useState(false) 
    const [leadPage, setLeadPage] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        loadLeads()
    }
        , [])
    const loadLeads = async () => {
        setIsLoading(true)
        const newLeads = await getAPI("api/business/leads")
        const leadsWithEmail = newLeads.data.filter(lead => lead.email && lead.email.trim() !== "");
        setLeads(leadsWithEmail)
        setIsLoading(false)
    }

    const handleExtraUser = (text, type) => {
        setLeadData({ ...leadData, [type]: text })
    }
    const addLead = async () => {
        const query = "api/business/lead/create"
        const body = {}
        body.first_name = leadData.name
        body.last_name = ""
        body.email = leadData.email
        const add = await postAPI(query, body)
        if (add.status === "ok") {
            loadLeads()
        }
        openAddUser()
    }
    const openAddUser = () => {
        setExtraUser(!extraUser)
    }
    const handleSelectAll = () => {
        const copyLeads = [...leads]
        copyLeads.forEach(lead => lead.selected = !isActive)
        setLeads(copyLeads)
        setIsActive(!isActive)
    }
    const handleSelectNow = (index) => {
        const copyLeads = [...leads]
        copyLeads[index]["selected"] = !copyLeads[index]["selected"]
        setLeads(copyLeads)
    }
    const handleback = () => {
        if (leadPage >= 5) {
            setLeadPage(leadPage - 5)
        }
    }
    const goNext = () => {
        if (leadPage < leads.length) {
            setLeadPage(leadPage + 5)
        }
    }
    return (
        <VerticalLayout>
            <TitleAtom className={"standard-margin-bottom standard-margin"} title={"Verstuur via email"} />
            {!extraUser && <EmailNav back={handleback} next={goNext} leadPage={leadPage} nextPage={leads.length > (leadPage + 5)} selectAllActive={isActive} select={handleSelectAll} />}
            <VerticalLayout>
                {isLoading && <Spinner />}
                {!extraUser ? <SelectUsers leadPage={leadPage} users={leads} selectNow={handleSelectNow} /> : <ExtraUser input={handleExtraUser} add={addLead} />}
            </VerticalLayout>
            <HorizontalLayout style={{ width: "unset", alignItems: "center", margin: "1rem", gap: "1rem" }}>
                <IconButton
                    onClick={openAddUser}
                    style={{ padding: "0.5rem", height: "100%", width: extraUser && "100%", backgroundColor: "#F7F7F7", borderRadius: "calc(.25rem * var(--br-scale))" }}
                    icon2={!extraUser ? "plus" : "arrow-left"}
                />
                {!extraUser && <ModalButton style={{ width: "100%", height: "100%", fontWeight: "bold" }} title={"verstuur"} ></ModalButton>}
            </HorizontalLayout>
        </VerticalLayout>
    )

}

const SelectUsers = ({ users, selectNow, leadPage }) => {
    return (
        users.slice(leadPage, (5 + leadPage)).map((user, index) => {
            return (

                <SelectUser lead={user} selectNow={() => selectNow(index)} />

            )
        })
    )
}
const SelectUser = ({ lead, selectNow }) => {
    return (
        <HorizontalLayout style={{ width: "unset", backgroundColor: "#F7F7F7", margin: "1rem", padding: "0.5rem", paddingTop: "0.1rem", paddingBottom: "0.1rem", borderRadius: "calc(0.2rem * var(--br-scale))", marginBottom: "0.2rem", marginTop: "0.2rem" }}>
            <input onChange={selectNow} type="checkbox" checked={lead.selected} style={{ width: "unset" }} />
            <User avatar={`https://ui-avatars.com/api/?name=${lead.first_name + " " + lead.last_name}&background=random&color=fff&format=svg`} name={lead.first_name + " " + lead.last_name} email={lead.email} />

        </HorizontalLayout>
    )
}

const EmailNav = ({ select, selectAllActive, nextPage, leadPage, next, back }) => {
    return (
        <HorizontalLayout style={{ width: "unset", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
            <SelectAtom selectAllActive={selectAllActive} select={select} />
             <NextPage nextPage={nextPage} next={next} back={back} leadPage={leadPage} />
        </HorizontalLayout>
    )
}

const SelectAtom = ({ select, selectAllActive }) => {
    return (
        <HorizontalLayout style={{ marginLeft: "1rem", marginRight: "1rem", marginTop: "0rem", width: "unset", alignItems: "center", justifyContent: "center" }}>
            <input onChange={select} checked={selectAllActive} type="checkbox" style={{ width: "unset" }} />
            <TextAtom
                style={{ color: "var(--standard-text-color-light)", marginLeft: "0.5rem", fontSize: "0.85rem" }}
                className={"light-text"}
                title={"Selecteer alles"}
            />
        </HorizontalLayout>
    )
}

const NextPage = ({ leadPage, back, next, nextPage }) => {
    return (
        <>
            {leadPage > 0  && <TextAtom
                onClick={back}
                style={{ marginRight: "1rem", fontSize: "0.8rem", color: "var(--primary-600)", fontWeight: "400" , cursor:"pointer" }}
                title={"< vorige"}
            />}
            {nextPage == true && <TextAtom
                onClick={next}
                style={{ marginRight: "1rem", fontSize: "0.8rem", color: "var(--primary-600)", fontWeight: "400" , cursor:"pointer"}}
                title={"Volgende>"}
            />}

        </>
    )
}

const ExtraUser = ({ input, add }) => {
    const handleInput = (value, type) => {
        input(value, type)
    }
    return (
        <VerticalLayout style={{ width: "unset", margin: "1rem", backgroundColor: "#F7F7F7", padding: "1rem", height: "max-content" }}>
            <InputForm typeInput={(text) => handleInput(text, "name")} title={"Naam"} placeholder={"Naam"}>

            </InputForm>
            <InputForm typeInput={(text) => handleInput(text, "email")} title={"Email"} placeholder={"Email"}>

            </InputForm>
            <StandardButton
                onClick={add}
                title={"Voeg lead toe"}
                style={{ width: "100%", margin: 0, justifyContent: "center" }}
            />
        </VerticalLayout>
    )
}

const SettingsPage = ({ courseId: initialCourseId }) => {
    const toastContext = useContext(ToastContext)
    const navigationContext = useContext(PageContext)
    const courseId = initialCourseId ?? navigationContext?.sidebar?.courseID
    const [leadPreferences, setLeadPreferences] = useState({
        email: true,
        phone: false,
        name: false,
        company: false
    })
    const [leadActions, setLeadActions] = useState({
        autoReply: true,
        assignOwner: false,
        notifyTeam: false
    })
    const [leadTiming, setLeadTiming] = useState(null)
    const [isLoadingSettings, setIsLoadingSettings] = useState(true)

    const mapLeadFields = useCallback((fields) => ({
        email: fields?.email ?? true,
        phone: fields?.phone ?? false,
        name: fields?.name ?? false,
        company: fields?.company ?? false
    }), [])

    useEffect(() => {
        if (!courseId) {
            setIsLoadingSettings(false)
            return
        }

        let isActive = true

        const loadLeadSettings = async () => {
            setIsLoadingSettings(true)
            let timingUpdated = false
            try {
                const response = await getAPI(`api/courses/${courseId}/embed-settings`)
                if (!isActive) {
                    return
                }

                if (response?.status === "ok" && response?.data) {
                    const { timing, fields } = response.data
                    setLeadTiming(timing ?? "start")
                    setLeadPreferences(mapLeadFields(fields))
                    timingUpdated = true
                    return
                }

                if (response?.response_type === "invalid_parameters") {
                    toastContext?.showToast(<>Lead-instellingen konden niet worden geladen.</>, "error", 2000)
                } else if (response?.status === "error" && response?.message !== "Not found") {
                    toastContext?.showToast(<>Lead-instellingen niet gevonden voor deze cursus.</>, "error", 2000)
                }
            } catch (error) {
                console.error("Failed to load embed lead settings", error)
                toastContext?.showToast(<>Lead-instellingen konden niet worden geladen.</>, "error", 2000)
            } finally {
                if (isActive) {
                    if (!timingUpdated) {
                        setLeadTiming((previous) => previous ?? "start")
                    }
                    setIsLoadingSettings(false)
                }
            }
        }

        loadLeadSettings()

        return () => {
            isActive = false
        }
    }, [courseId, mapLeadFields, toastContext])

    const handleLeadToggle = (key) => {
        if (isLoadingSettings) {
            return
        }

        const currentPreferences = leadPreferences
        const nextValue = !currentPreferences[key]

        if ((key === "email" || key === "phone") && !nextValue) {
            const alternate = key === "email" ? "phone" : "email"
            if (!currentPreferences[alternate]) {
                return
            }
        }

        const nextPreferences = { ...currentPreferences, [key]: nextValue }
        setLeadPreferences(nextPreferences)
        persistLeadSettings(leadTiming ?? "start", nextPreferences)
    }

    const leadOptions = [
        { key: "email", label: "E-mail" },
        { key: "phone", label: "Telefoonnummer" },
        { key: "name", label: "Naam" },
        { key: "company", label: "Bedrijf" }
    ]
    const leadActionOptions = [
        { key: "autoReply", label: "Stuur automatische reactie" },
        { key: "assignOwner", label: "Wijs eigenaar toe" },
        { key: "notifyTeam", label: "Notificeer salesteam" }
    ]

    const isDisabled = (key) => {
        if (key === "email") {
            return leadPreferences.email && !leadPreferences.phone
        }
        if (key === "phone") {
            return leadPreferences.phone && !leadPreferences.email
        }
        return false
    }

    const handleActionToggle = (key) => {
        setLeadActions((previous) => ({ ...previous, [key]: !previous[key] }))
    }

    const persistLeadSettings = useCallback(async (nextTiming, nextPreferences) => {
        if (!courseId) {
            return { success: false }
        }

        try {
            const response = await updateAPI(`api/courses/${courseId}/embed-settings`, {
                timing: nextTiming,
                fields: nextPreferences
            })

            if (response?.status === "ok") {
                const updatedTiming = response.data?.timing ?? nextTiming
                const updatedFields = mapLeadFields(response.data?.fields ?? nextPreferences)
                setLeadTiming(updatedTiming)
                setLeadPreferences(updatedFields)
                toastContext?.showToast(<>Lead-instellingen bijgewerkt.</>, "success", 1500)
                return { success: true }
            }

            if (response?.response_type === "invalid_parameters") {
                toastContext?.showToast(<>Onjuiste instellingen, controleer de velden.</>, "error", 2000)
            } else {
                toastContext?.showToast(<>Bijwerken van lead-instellingen is mislukt.</>, "error", 2000)
            }
        } catch (error) {
            console.error("Failed to update embed lead settings", error)
            toastContext?.showToast(<>Bijwerken van lead-instellingen is mislukt.</>, "error", 2000)
        }

        return { success: false }
    }, [courseId, mapLeadFields, toastContext])

    const handleLeadTimingChange = useCallback((timingId) => {
        if (!timingId || timingId === leadTiming || isLoadingSettings) {
            return
        }

        setLeadTiming(timingId)
        persistLeadSettings(timingId, leadPreferences)
    }, [leadTiming, leadPreferences, persistLeadSettings, isLoadingSettings])

    const leadTimingOptions = [
        {
            id: "start",
            label: "Begin",
            description: "De lead vult zijn/haar gegevens aan het begin van de e-learning in."
        },
        {
            id: "middle",
            label: "Midden",
            description: "De lead vult zijn/haar gegevens in het midden van de e-learning in. Dit wordt willekeurig bepaald."
        },
        {
            id: "end",
            label: "Einde",
            description: "De lead vult zijn/haar gegevens aan het einde van de e-learning in om zijn/haar resultaten in te zien."
        }
    ]

    const leadTimingButtons = leadTimingOptions.map((option) => ({
        id: option.id,
        content: option.label,
        selected: leadTiming === option.id,
        onClick: () => handleLeadTimingChange(option.id)
    }))

    const selectedLeadTiming = leadTimingOptions.find((option) => option.id === leadTiming)

    return (
        <VerticalLayout style={{ width: "100%"}}>
        <TitleAtom className={"standard-margin"} title={"Lead-instellingen"} />
           {!isLoadingSettings ? (
            <>
                <LeadInfoToggle leadOptions={leadOptions} leadPreferences={leadPreferences} handleLeadToggle={handleLeadToggle} isDisabled={isDisabled} />
                <LeadTimingOptions leadTimingButtons={leadTimingButtons} selectedLeadTiming={selectedLeadTiming} />
            </>
            ) : (<VerticalLayout className="center"><Spinner /></VerticalLayout> )}
        </VerticalLayout>
    )
}


const LeadInfoToggle = ({ leadOptions, leadPreferences, handleLeadToggle, isDisabled }) => {
    return (
        <VerticalLayout style={{ width: "auto", margin: "1rem", gap: "1rem", height: "min-content" }}>
            <TextAtom title={"Leadgegevens"} style={{ fontWeight: "bold"}} />
            <VerticalLayout style={{ gap: "0.75rem", width: "unset", backgroundColor: "#F7F7F7", borderRadius: "calc(.35rem * var(--br-scale))", padding: "1rem" }}>
                {leadOptions.map((option) => (
                    <HorizontalLayout key={option.key} style={{ alignItems: "center", gap: "0.75rem" }}>
                        <Checkbox
                            name={option.key}
                            value={option.key}
                            checked={leadPreferences[option.key]}
                            onChange={() => handleLeadToggle(option.key)}
                            disabled={isDisabled(option.key)}
                        />
                        <TextAtom title={option.label} style={{ fontSize: "0.9rem" }} />
                    </HorizontalLayout>
                ))}
            </VerticalLayout>
        </VerticalLayout>
    )
}

const LeadTimingOptions = ({ leadTimingButtons, selectedLeadTiming }) => {
    return (
        <VerticalLayout style={{ width: "auto", margin: "1rem", gap: "1rem", height: "min-content" }}>
            <TextAtom title={"Timing invulmogelijkheid"} style={{ fontWeight: "bold", marginTop: "1rem" }} />
            <VerticalLayout style={{ gap: "0.75rem", width: "unset", backgroundColor: "#F7F7F7", borderRadius: "calc(.35rem * var(--br-scale))", padding: "1rem" }}>
                <ButtonGroup size={"fullwidth"} buttons={leadTimingButtons} />
                {selectedLeadTiming && (
                    <TextAtom
                        title={selectedLeadTiming.description}
                        style={{ fontSize: "0.85rem", color: "#6B7280" }}
                    />
                )}
            </VerticalLayout>
        </VerticalLayout>
    )
}